<template>
  <vue-draggable-resizable
    style="border: none; opacity: 0.9;"
    :resizable="false"
    :w="300"
    :h="130"
    :z="999"
    :x="xpos"
    :y="ypos"
    :parent="true"
    :drag-handle="'.drag-handle'"
  >
    <v-card outline class="mx-auto">
      <v-system-bar color="green" class="drag-handle">
        <v-icon>mdi-information-outline</v-icon>
        <span>Filtr</span>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('close-filter')">mdi-close</v-icon>
      </v-system-bar>
      <v-card-title>
        <h5>Parametry filtrowania</h5>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="date"
                  label="Data od"
                  prepend-icon="event"
                  width="100"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                class="ma-0 pa-n2"
                v-model="date"
                width="200"
                no-title
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="6" md="6">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="190px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="date"
                  label="Data do"
                  prepend-icon="event"
                  width="100"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                width="200"
                no-title
                v-model="date"
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-card-text>
      <v-slider
        v-model="time"
        :max="6"
        :tick-labels="labels"
        class="mx-4"
        ticks
      ></v-slider>
      <v-card-actions>
        <v-btn text color="primary">Ukryj</v-btn>
      </v-card-actions>
    </v-card>
    ></vue-draggable-resizable
  >
</template>

<script>
import VueDraggableResizable from "vue-draggable-resizable";

export default {
  name: "filterWindow",
  components: { VueDraggableResizable },
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      modal: false,
      menu2: false,
      xpos: window.innerWidth - 300,
      ypos: window.innerHeight - 350,
      time: 0,
      labels: ["Nie", "Pon", "Wto", "Śro", "Czw", "Pią", "Sob"]
    };
  },
  computed: {
    currentTime() {
      var today = new Date();
      var time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      return time;
    }
  },
  methods: {}
};
</script>
